// import React from "react";
// import { Bar, Line, Pie } from "react-chartjs-2";
// import ContentLoader from "react-content-loader";

// const ChartSkeleton = ({ type, width = 600, height = 300 }) => {
//   const baseColor = "#e2e8f0";
//   const highlightColor = "#f1f5f9";

//   if (type === "bar") {
//     return (
//       <ContentLoader
//         speed={2}
//         width={width}
//         height={height}
//         backgroundColor={baseColor}
//         foregroundColor={highlightColor}
//         className="rounded-xl"
//       >
//         {[...Array(6)].map((_, i) => (
//           <rect
//             key={i}
//             x={40 + i * 60}
//             y={Math.random() * 100 + 40}
//             rx="6"
//             ry="6"
//             width="40"
//             height="180"
//           />
//         ))}
//       </ContentLoader>
//     );
//   }

//   if (type === "line") {
//     return (
//       <ContentLoader
//         speed={2}
//         width={width}
//         height={height}
//         backgroundColor={baseColor}
//         foregroundColor={highlightColor}
//         className="rounded-xl"
//       >
//         {[...Array(6)].map((_, i) => (
//           <rect
//             key={i}
//             x={40 + i * 60}
//             y={Math.random() * 80 + 60}
//             rx="4"
//             ry="4"
//             width="40"
//             height="4"
//           />
//         ))}
//       </ContentLoader>
//     );
//   }

//   if (type === "pie") {
//     return (
//       <ContentLoader
//         speed={2}
//         width={width}
//         height={height}
//         backgroundColor={baseColor}
//         foregroundColor={highlightColor}
//         className="rounded-xl"
//       >
//         <circle cx="150" cy="120" r="80" />
//       </ContentLoader>
//     );
//   }

//   return null;
// };

// export default function ChartWithSkeleton({
//   type = "bar",
//   data,
//   options = {},
//   loading = false,
//   width = 600,
//   height = 300,
// }) {
//   const chartProps = { data, options };

//   const chartMap = {
//     bar: <Bar {...chartProps} />,
//     line: <Line {...chartProps} />,
//     pie: <Pie {...chartProps} />,
//   };

//   return (
//     <div
//       className={`relative bg-white dark:bg-gray-900 shadow-md rounded-2xl p-4 flex justify-center items-center ${
//         loading ? "animate-pulse" : ""
//       }`}
//       style={{ width, height }}
//     >
//       {loading ? (
//         <ChartSkeleton type={type} width={width - 40} height={height - 40} />
//       ) : (
//         chartMap[type] || <p>نوع چارت نامعتبر است</p>
//       )}
//     </div>
//   );
// }
// import React from "react";
// import { Bar, Line, Pie } from "react-chartjs-2";
// import ContentLoader from "react-content-loader";

// const ChartSkeleton = ({ type, width = 600, height = 300 }) => {
//   const baseColor = "#e2e8f0";
//   const highlightColor = "#f1f5f9";

//   if (type === "bar") {
//     return (
//       <ContentLoader
//         speed={2}
//         width={width}
//         height={height}
//         backgroundColor={baseColor}
//         foregroundColor={highlightColor}
//         className="rounded-xl"
//       >
//         {[...Array(6)].map((_, i) => (
//           <rect
//             key={i}
//             x={40 + i * 60}
//             y={Math.random() * 100 + 40}
//             rx="6"
//             ry="6"
//             width="40"
//             height="180"
//           />
//         ))}
//       </ContentLoader>
//     );
//   }

//   if (type === "line") {
//     return (
//       <ContentLoader
//         speed={2}
//         width={width}
//         height={height}
//         backgroundColor={baseColor}
//         foregroundColor={highlightColor}
//         className="rounded-xl"
//       >
//         {[...Array(6)].map((_, i) => (
//           <rect
//             key={i}
//             x={40 + i * 60}
//             y={Math.random() * 80 + 60}
//             rx="4"
//             ry="4"
//             width="40"
//             height="4"
//           />
//         ))}
//       </ContentLoader>
//     );
//   }

//   if (type === "pie") {
//     return (
//       <ContentLoader
//         speed={2}
//         width={width}
//         height={height}
//         backgroundColor={baseColor}
//         foregroundColor={highlightColor}
//         className="rounded-xl"
//       >
//         <circle cx="150" cy="120" r="80" />
//       </ContentLoader>
//     );
//   }

//   return null;
// };

// export default function ChartWithSkeleton({
//   type = "bar",
//   data,
//   options = {},
//   loading = false,
//   width = 600,
//   height = 300,
// }) {
//   const safeData = data && data.labels ? data : { labels: [], datasets: [] };

//   const chartMap = {
//     bar: <Bar data={safeData} options={options} />,
//     line: <Line data={safeData} options={options} />,
//     pie: <Pie data={safeData} options={options} />,
//   };

//   return (
//     <div
//       className={`relative bg-white dark:bg-gray-900 shadow-md rounded-2xl p-4 flex justify-center items-center ${
//         loading ? "animate-pulse" : ""
//       }`}
//       style={{ width, height }}
//     >
//       {loading ? (
//         <ChartSkeleton type={type} width={width - 40} height={height - 40} />
//       ) : (
//         chartMap[type] || <p>نوع چارت نامعتبر است</p>
//       )}
//     </div>
//   );
// }
import React from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import ContentLoader from "react-content-loader";

const ChartSkeleton = ({ type, width = 600, height = 300 }) => {
  const baseColor = "#e2e8f0";
  const highlightColor = "#f8fafc";

  if (type === "bar") {
    return (
      <ContentLoader
        speed={2}
        width={width}
        height={height}
        backgroundColor={baseColor}
        foregroundColor={highlightColor}
      >
        {/* محور */}
        <rect x="40" y="20" rx="4" ry="4" width="2" height={height - 40} />
        <rect x="40" y={height - 30} rx="4" ry="4" width={width - 60} height="2" />

        {/* میله‌ها */}
        {[...Array(6)].map((_, i) => (
          <rect
            key={i}
            x={70 + i * 80}
            y={Math.random() * 100 + 60}
            rx="6"
            ry="6"
            width="40"
            height="120"
          />
        ))}
      </ContentLoader>
    );
  }

  if (type === "line") {
    return (
      <ContentLoader
        speed={2}
        width={width}
        height={height}
        backgroundColor={baseColor}
        foregroundColor={highlightColor}
      >
        {/* محور */}
        <rect x="40" y="20" rx="4" ry="4" width="2" height={height - 40} />
        <rect x="40" y={height - 30} rx="4" ry="4" width={width - 60} height="2" />

        {/* چند خط شبیه منحنی نمودار */}
        {[...Array(2)].map((_, i) => (
          <path
            key={i}
            d={`M40 ${height - 80 - i * 10} 
               Q ${width / 3} ${height - 120 - i * 20}, 
                 ${(width / 3) * 2} ${height - 60 + i * 10}
               T ${width - 60} ${height - 100 + i * 15}`}
            stroke={highlightColor}
            strokeWidth="3"
            fill="none"
          />
        ))}
      </ContentLoader>
    );
  }

  if (type === "pie") {
    return (
      <ContentLoader
        speed={2}
        width={width}
        height={height}
        backgroundColor={baseColor}
        foregroundColor={highlightColor}
      >
        <circle cx={width / 2} cy={height / 2} r={80} />
        <path
          d={`M${width / 2} ${height / 2} L${width / 2} ${height / 2 - 80} A80 80 0 0 1 ${width / 2 + 60} ${height / 2 + 60} Z`}
          fill={highlightColor}
        />
      </ContentLoader>
    );
  }

  return null;
};

export default function ChartWithSkeleton({
  type = "bar",
  data,
  options = {},
  loading = false,
  width = 600,
  height = 300,
}) {
  const safeData = data && data.labels ? data : { labels: [], datasets: [] };

  const chartMap = {
    bar: <Bar data={safeData} options={options} />,
    line: <Line data={safeData} options={options} />,
    pie: <Pie data={safeData} options={options} />,
  };

  return (
    <div
      className={`relative bg-white dark:bg-gray-900 shadow-md rounded-2xl p-4 flex justify-center items-center ${
        loading ? "animate-pulse" : ""
      }`}
      style={{ width, height }}
    >
      {loading ? (
        <ChartSkeleton type={type} width={width - 40} height={height - 40} />
      ) : (
        chartMap[type] || <p>نوع چارت نامعتبر است</p>
      )}
    </div>
  );
}
